import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../hooks/useAPI';
import ProductShowcase from '../../components/business/ProductShowcase';
import Loading from '../../components/ui/Loading';
import ErrorMessage from '../../components/ui/ErrorMessage';
import Pagination from '../../components/ui/Pagination';
import Button from '../../components/ui/Button';
import { getRegistrationProductList } from '../../services/api/copyright';

const CopyrightProducts = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  // 筛选状态
  const [filters, setFilters] = useState({
    category: 'all',
    search: ''
  });
  
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 12;

  const { data, loading, error, refetch } = useAPI(
    () => getRegistrationProductList({
      page: currentPage,
      pageSize,
      category: filters.category !== 'all' ? filters.category : undefined,
      search: filters.search || undefined
    }),
    [currentPage, filters, i18n.language]
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCategoryChange = (category) => {
    setFilters(prev => ({ ...prev, category }));
    setCurrentPage(1); // 重置到第一页
  };

  const handleSearchChange = (search) => {
    setFilters(prev => ({ ...prev, search }));
    setCurrentPage(1); // 重置到第一页
  };

  const handleProductClick = (product) => {
    // 存储产品信息到sessionStorage
    sessionStorage.setItem('selectedProduct', JSON.stringify(product));
    navigate(`/copyright/products/${product.id}`);
  };

  if (loading) {
    return (
        <div className="flex justify-center items-center min-h-[400px]">
          <Loading />
        </div>
    );
  }

  if (error) {
    return (
        <div className="container mx-auto px-4 py-8">
          <ErrorMessage 
            message={error} 
            onRetry={refetch}
          />
        </div>
    );
  }

  const { products = [], categories = [], pagination = {} } = data || {};

  return (
      <div className="container mx-auto px-4 py-8">
        {/* 页面标题 */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {t('copyright.products.title', '登记产品展示')}
          </h1>
        </div>

        {/* 筛选控件 */}
        <div className="mb-8 space-y-4">
          {/* 分类筛选 */}
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={filters.category === category.id ? 'primary' : 'outline'}
                size="sm"
                onClick={() => handleCategoryChange(category.id)}
                className="text-sm"
              >
                {category.name} ({category.count})
              </Button>
            ))}
          </div>

          {/* 搜索框 */}
          {/* <div className="max-w-md">
            <input
              type="text"
              placeholder={t('copyright.products.searchPlaceholder')}
              value={filters.search}
              onChange={(e) => handleSearchChange(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div> */}
        </div>

        {/* 产品展示 */}
        <div className="mb-8">
          {products.length > 0 ? (
            <ProductShowcase 
              products={products}
              layout="grid"
              onProductClick={handleProductClick}
            />
          ) : (
            <div className="text-center py-12 text-gray-500">
              {filters.search || filters.category !== 'all' 
                ? t('copyright.products.noSearchResults')
                : t('copyright.products.noData')
              }
            </div>
          )}
        </div>

        {/* 分页 */}
        {pagination.totalPages > 1 && (
          <div className="flex justify-center">
            <Pagination
              currentPage={currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
  );
};

export default CopyrightProducts; 